import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faQuestion } from '@fortawesome/free-solid-svg-icons';

function HomeScreenIcons({ toggleMenuDispatch, openTutorialDispatch }) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
            }}
        >
            <span
                style={{
                    textAlign: 'center',
                    color: 'white',
                    display: 'block',
                    size: '100px',
                    marginLeft: '20px',
                    marginBottom: '10px',
                    opacity: 0.8,
                    cursor: 'pointer',
                }}
                onClick={toggleMenuDispatch}
            >
                <FontAwesomeIcon icon={faBars} />
            </span>
            <span
                style={{
                    textAlign: 'center',
                    color: 'white',
                    display: 'block',
                    size: '100px',
                    marginRight: '20px',
                    marginBottom: '10px',
                    opacity: 0.8,
                    cursor: 'pointer',
                }}
                onClick={openTutorialDispatch}
            >
                <FontAwesomeIcon icon={faQuestion} />
            </span>
        </div>
    );
}

export default HomeScreenIcons;
